;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.subcontractor.list', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    const listState = {
      name: 'subcontractor.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      resolve: {
        pagination: [ 'PaginationModel', function (PaginationModel) {
          return PaginationModel.get('subcontractorList')
        }]
      },
      views: {
        'main@': {
          controller: 'SubcontractorListController',
          template: '<subcontractor-list pagination="list.pagination"></subcontractor-list>',
          controllerAs: 'list'
        },
        'toolbar@': {
          controller: 'SubcontractorListToolbarController',
          templateUrl: '/app/modules/subcontractor/list/controllers/subcontractor-list-toolbar.template.html',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Liste des sous-traitants',
        parent: ''
      }
    }

    $stateProvider
      .state(listState)
  }
})(window.angular)
